<template>
	<div v-if="Data" class="limits-block-wrapper">
		<div class="progress-layer">
			<template v-for="(type, i) in Data">
				<div class="progress-text" :key="'pt-' + i">{{ type.name | ftc }}: <span class="pull-right">{{ type.data['ordered'] }}<span v-if="type.data['limit_max_count'] < 100000"> {{ 'main/out_of' | ftc }} {{ type.data['limit_max_count'] }}</span></span></div>
				<div class="progress progress-striped progress-wrapper" :key="'pw-' + i">
					<div class="progress-bar" :class="percents(i) < 99.99 ? 'progress-bar-info' : 'progress-bar-danger'" :style="'width: ' + percents(i) + '%'"></div>
				</div>
				<div class="progress-underline-text" :key="'ptu-' + i"><span v-if="type.data['limit_child_count']">{{ 'account/limit_not_greater' | ftc }} {{ type.data['limit_child_count'] }} {{ 'account/limit_in_service' | ftc }}</span></div>
			</template>
		</div>
		<span class="clearfix"></span>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Limits',
	//=========================================================================
	// свойства, задаются только родителем
	//=========================================================================
	props: ['data'],
	//=========================================================================
	// локальные свойства
	//=========================================================================
	data() {
		return {
			Data: false,
			Names: {
				1: 'VDS',
				2: 'IPv4',
				3: 'RAM',
				4: 'NVMe',
				5: 'vCPU',
				6: 'Трафик',
				7: 'IPv6',
				8: 'Нагрузка',
				9: 'Снимок',
				10: 'ISO',
				11: 'SSL-сертификат',
				12: 'Домены',
				14: 'DNS'
			}
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		Count() {
			return 1
		}
	},
	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		this.init()
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация
		//---------------------------------------------------------------------
		init() {
			// обнуляем
			this.Data = false
			// проверка входного параметра
			if (!this.data || !this.data['servicetype']) return

			// бежим по константам - типам услуг
			for (let k in Vue.Constants)
			{
				// нам нужны только типы услуг
				if (k.indexOf('SERVICE_TYPE') !== 0) continue

				// индекс типа
				let _index = Vue.Constants[k]
				// переменные
				let _str = ''
				let _num = 0
				let _obj = false
				let _name = false

				// ищем индекс типа в данных
				for (let l in this.data['servicetype'])
				{
					_str = '[' + _index + ']'
					_num = l.indexOf(_str)
					// если нашли
					if (_num > -1)
					{
						if (!_obj) _obj = {}
						_obj[l.substr(0, _num)] = this.data['servicetype'][l]['value']

						let _title = this.data['servicetype'][l]['title']
						_num = _title.indexOf(':')
						if (_num > -1) _name = _title.substr(0, _num)
					}
				}

				// есть найденные данные - запишем их
				if (_obj)
				{
					if (!this.Data) this.Data = {}
					this.Data[_index] = {
						'name': _name !== false ? _name : this.Names[_index] ? this.Names[_index] : k.substr(13).replace('VDS_', ''),
						'data': _obj
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// расчет процента
		//---------------------------------------------------------------------
		percents(idx) {
			// получим индекс в числовом виде
			let _idx = parseInt(idx, 10)
			if (isNaN(_idx)) return 0

			// если данных нет
			if (!this.Data || !this.Data[idx]) return 0

			// получим параметры в числовом виде
			let _max = parseInt(this.Data[idx]['data']['limit_max_count'], 10)
			let _ordered = parseInt(this.Data[idx]['data']['ordered'], 10)

			// проверка на корректность
			if (isNaN(_max) || isNaN(_ordered)) return 0
			if (_max < 0 || _ordered < 0) return 0

			// если у нас максиальное значение ноль
			if (_max === 0)
			{
				if (_ordered > 0) return 100
				else return 0
			}

			// считаем просто процент
			let _proc = parseInt(_ordered * 100.0 / _max)
			if (_proc <= 0) _proc = 0
			if (_proc >= 100) _proc = 100

			// ответ
			return _proc
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		// если изменились данные
		'data': function(data) {
			this.init()
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.limits-block-wrapper {
	margin-top: 10px;
	padding-top: 20px;
	width: 100%;
	border: 1px solid #eee;
	border-radius: 4px;
}
.progress-layer {
	width: 100%;
	padding: 0 10px;
	float: none;
}
.progress-wrapper {
	height: 8px;
	margin-bottom: 0;
}
.progress-text {
	padding: 0 5px;
	font-size: 14px;
	font-weight: 500;
}
.progress-underline-text {
	padding: 0 5px;
	text-align: right;
	font-size: 11px;
	height: 30px;
}

@media (max-width: 767px) {
	.progress-text {
		font-size: 11px;
		font-weight: 400;
	}
}
</style>



// WEBPACK FOOTER //
// limits.vue?17e86dda